/* Vendor builder (sections/vendor-builder.liquid).
   Filters are rendered in Liquid; cards are rendered here from the section's
   product JSON so filtering stays client-side. Add new filter vocabulary in
   MATCHERS below, never in Liquid. */
(function () {
  'use strict';

  /* One predicate per filter key: (product, chosenValue, allChoices) => bool */
  var MATCHERS = {
    source: function (p, v) { return p.source.indexOf(v) > -1; },
    spanCount: function (p, v, s) {
      if (!p.spanMax) return s.source !== 'span';
      return +v <= p.spanMax;
    },
    output: function (p, v) { return p.modes.indexOf(v) > -1; },
    media: function (p, v) { return v === 'sfp' ? p.monitor === 'sfp' : true; },
    mount: function (p, v) {
      if (v === 'din') return !!p.din;
      if (v === 'shelf') return !!p.portable;
      return true;
    }
  };

  /* Buyer guidance appended to a matched card without excluding it. Copy comes from section settings. */
  function notesFor(p, s, notes) {
    var n = [];
    if (notes.copperSfp && s.media === 'copper' && p.monitor === 'sfp') n.push(notes.copperSfp);
    if (notes.rackPortable && s.mount === 'rack' && p.portable) n.push(notes.rackPortable);
    if (notes.din && s.mount === 'din' && p.din) n.push(notes.din);
    return n;
  }

  var PLACEHOLDER_FALLBACK = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 90'><rect width='160' height='90' fill='%23f4f4f4'/><rect x='52' y='27' width='56' height='36' rx='4' fill='none' stroke='%23b5b5b5' stroke-width='2'/><circle cx='80' cy='45' r='9' fill='none' stroke='%23b5b5b5' stroke-width='2'/><rect x='66' y='21' width='14' height='7' rx='2' fill='%23b5b5b5'/></svg>";

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Vendor builder: bad JSON in #' + id, e);
      return null;
    }
  }

  /* Front-panel drawing from builder.schematic. net/mon: [[port id, caption]].
     rack draws a 1U faceplate with ears; pairs brackets network ports in twos;
     oneway draws the diode arrow; mon caption "SFP" draws a cage. */
  function schematic(p) {
    var S = p.schematic;
    if (!S || !S.net || !S.mon) return '<span>' + esc(p.sku) + '</span>';
    var W = 520, H = S.rack ? 150 : 170, pad = 16;
    var pw = S.rack ? 34 : 44, ph = S.rack ? 30 : 38, gap = S.rack ? 8 : 14;
    var all = S.net.concat(S.mon);
    var sfp = S.mon[0] && S.mon[0][1] === 'SFP';
    function cx(i) {
      if (S.rack) return pad + 40 + i * (pw + gap) + (i >= S.net.length ? 26 : 0);
      return (W / 2 - (all.length * pw + (all.length - 1) * gap) / 2) + i * (pw + gap) + (i >= S.net.length ? 22 : 0);
    }
    var py = S.rack ? 52 : 58;
    var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + esc(p.title) + ' front panel: ' + S.net.length + ' network ports, ' + S.mon.length + ' monitor ports">';
    s += '<rect x="' + pad + '" y="22" width="' + (W - 2 * pad) + '" height="' + (S.rack ? 96 : 112) + '" rx="' + (S.rack ? 4 : 10) + '" fill="#000" stroke="#09741f" stroke-width="2.5"/>';
    if (S.rack) {
      s += '<rect x="' + (pad - 10) + '" y="30" width="10" height="80" fill="#09741f"/><rect x="' + (W - pad) + '" y="30" width="10" height="80" fill="#09741f"/>';
      [38, 102].forEach(function (y) {
        s += '<circle cx="' + (pad - 5) + '" cy="' + y + '" r="2.5" fill="#fff"/><circle cx="' + (W - pad + 5) + '" cy="' + y + '" r="2.5" fill="#fff"/>';
      });
    }
    s += '<text x="' + (W - pad - 14) + '" y="' + (S.rack ? 33 : 44) + '" text-anchor="end" fill="#fff" font-size="11" font-family="Lato,sans-serif" letter-spacing="1">' + esc(p.sku) + '</text>';
    all.forEach(function (port, i) {
      var id = port[0], lab = port[1], x = cx(i), mon = i >= S.net.length;
      var stroke = mon ? '#ffffff' : '#09741f';
      s += '<rect x="' + x + '" y="' + py + '" width="' + pw + '" height="' + ph + '" rx="3" fill="#0b0b0b" stroke="' + stroke + '" stroke-width="2"/>';
      if (mon && sfp) s += '<rect x="' + (x + 5) + '" y="' + (py + ph / 2 - 6) + '" width="' + (pw - 10) + '" height="12" rx="1" fill="#1e1e1e" stroke="' + stroke + '" stroke-width="1"/>';
      else s += '<path d="M' + (x + pw * 0.28) + ' ' + (py + ph) + ' v-' + (ph * 0.32) + ' h' + (pw * 0.44) + ' v' + (ph * 0.32) + '" fill="none" stroke="' + stroke + '" stroke-width="1.5"/>';
      s += '<circle cx="' + (x + pw - 7) + '" cy="' + (py + 7) + '" r="2.5" fill="' + (mon ? '#ffffff' : '#09741f') + '"/>';
      s += '<text x="' + (x + pw / 2) + '" y="' + (py - 6) + '" text-anchor="middle" fill="#fff" font-size="12" font-family="Lato,sans-serif" font-weight="700">' + esc(id) + '</text>';
      if (lab) s += '<text x="' + (x + pw / 2) + '" y="' + (py + ph + 16) + '" text-anchor="middle" fill="#fff" font-size="10.5" font-family="Lato,sans-serif">' + esc(lab) + '</text>';
    });
    if (S.pairs) {
      for (var i = 0; i < S.net.length; i += 2) {
        var bx = cx(i);
        s += '<path d="M' + (bx + 2) + ' ' + (py + ph + 22) + ' v4 h' + (pw * 2 + gap - 4) + ' v-4" fill="none" stroke="#fff" stroke-width="1.5"/>';
      }
    }
    if (S.oneway) {
      var x0 = cx(S.net.length - 1) + pw + 2, x1 = cx(S.net.length) - 2;
      s += '<path d="M' + x0 + ' ' + (py + ph / 2) + ' H' + (x1 - 6) + '" stroke="#fff" stroke-width="2" stroke-dasharray="3 3"/><path d="M' + (x1 - 8) + ' ' + (py + ph / 2 - 5) + ' l6 5 -6 5" fill="none" stroke="#fff" stroke-width="2"/>';
    }
    s += '<rect x="' + pad + '" y="' + (H - 8) + '" width="10" height="4" fill="#09741f"/><text x="' + (pad + 16) + '" y="' + (H - 3) + '" fill="#333" font-size="11" font-family="Lato,sans-serif">Network side</text>';
    s += '<rect x="' + (pad + 110) + '" y="' + (H - 8) + '" width="10" height="4" fill="#000" stroke="#333" stroke-width="1"/><text x="' + (pad + 126) + '" y="' + (H - 3) + '" fill="#333" font-size="11" font-family="Lato,sans-serif">Monitor side</text>';
    return s + '</svg>';
  }

  function cleanTitle(title, sku) {
    if (!sku) return title;
    return title.replace(new RegExp('[\\s\\u00a0]*[-–][\\s\\u00a0]*' + sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$'), '');
  }

  function init(root) {
    if (!root || root.vbReady) return;
    var id = root.getAttribute('data-vendor-builder');
    var config = readJSON('vb-config-' + id);
    var products = readJSON('vb-products-' + id);
    if (!config || !products) return;
    root.vbReady = true;

    var L = config.labels;
    var filtersEl = root.querySelector('[data-vb-filters]');
    var cardsEl = root.querySelector('[data-vb-cards]');
    var emptyEl = root.querySelector('[data-vb-empty]');
    var countEl = root.querySelector('[data-vb-count]');
    var toastEl = root.querySelector('[data-vb-toast]');
    var groups = Array.prototype.slice.call(filtersEl.querySelectorAll('.vb__f'));

    products.forEach(function (p) {
      p.source = p.source || [];
      p.modes = p.modes || [];
      p.facts = p.facts || {};
      p.accessories = p.accessories || [];
    });

    var filters = groups.map(function (g) {
      return { key: g.getAttribute('data-f'), dependsOn: g.getAttribute('data-depends') || '', el: g };
    });
    filters.forEach(function (f) {
      if (!MATCHERS[f.key]) {
        f.ignored = true;
        if (config.designMode) console.warn('Vendor builder: filter key "' + f.key + '" has no matcher in vendor-builder.js; it is shown but ignored.');
      }
    });

    function val(f) {
      var checked = f.el.querySelector('input:checked');
      return checked ? checked.value : '';
    }

    function state() {
      var s = {};
      filters.forEach(function (f) { s[f.key] = val(f); });
      return s;
    }

    function qtyFor(sku) {
      return (config.qtyRules && config.qtyRules[sku]) || 1;
    }

    function accessoryRows(p) {
      return p.accessories.map(function (a, i) {
        var title = esc(cleanTitle(a.title, a.sku));
        if (a.terms && a.terms.length) {
          var opts = a.terms.map(function (t) {
            return '<option value="' + t.id + '">' + esc(t.label) + (t.priceText ? ' · ' + esc(t.priceText) : '') + '</option>';
          }).join('');
          return '<label><input type="checkbox" data-acc="' + i + '"><span>' + title + '</span>' +
            '<span class="vb__p"><select data-term="' + i + '" aria-label="' + esc(L.term) + '">' + opts + '</select></span></label>';
        }
        var q = qtyFor(a.sku);
        var price = a.priceText ? esc(a.priceText) + (q > 1 ? ' ' + esc(L.each) : '') : esc(L.callForPricing);
        return '<label><input type="checkbox" data-acc="' + i + '" data-qty="' + q + '"><span>' + (q > 1 ? q + ' × ' : '') + title + '</span>' +
          '<span class="vb__p">' + price + '</span></label>';
      }).join('');
    }

    function card(p, index, notes, best) {
      var img = p.image || config.placeholderImage || PLACEHOLDER_FALLBACK;
      var hasPrice = p.price != null && p.variantId;
      var why = [p.why].concat(notes).filter(Boolean).join(' ');
      var facts = [
        [L.factNetwork, p.facts.network],
        [L.factMonitor, p.facts.monitor],
        [L.factSpeed, p.facts.speed],
        [L.factForm, p.facts.form]
      ].filter(function (f) { return f[1]; });
      var html = '<article class="vb__card' + (best ? ' is-best' : '') + '" data-index="' + index + '">';
      html += '<div class="vb__fit' + (best ? '' : ' vb__fit--alt') + '">' + esc(best ? L.bestFit : (p.cls || ' ')) + '</div>';
      html += '<div class="vb__media" tabindex="0" role="button" aria-label="' + esc(L.mediaLabel) + '">' +
        '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="754" height="424">' +
        (p.schematic ? '<div class="vb__sch">' + schematic(p) + '</div><span class="vb__hint">' + esc(L.hint) + '</span>' : '') +
        '</div>';
      html += '<div class="vb__body">';
      html += '<div class="vb__vend">' + esc(p.vendor || config.vendorName) + '</div>';
      html += '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>';
      if (p.sku) html += '<div class="vb__sku">' + esc(L.sku) + ' ' + esc(p.sku) + '</div>';
      html += hasPrice
        ? '<div class="vb__price">' + esc(p.priceText) + '</div>'
        : '<div class="vb__price vb__price--none">' + esc(L.callForPricing) + '</div>';
      if (facts.length) {
        html += '<ul class="vb__facts">' + facts.map(function (f) {
          return '<li><span>' + esc(f[0]) + '</span>' + esc(f[1]) + '</li>';
        }).join('') + '</ul>';
      }
      if (why) html += '<p class="vb__why">' + esc(why) + '</p>';
      if (hasPrice && p.accessories.length) {
        html += '<div class="vb__acc"><h4>' + esc(L.accessories) + '</h4>' + accessoryRows(p) + '</div>';
      }
      if (hasPrice) {
        html += '<form class="vb__buy" action="' + esc(config.cartAddUrl) + '" method="post" data-buy>' +
          '<div class="vb__qty">' +
          '<button type="button" data-step="-1" aria-label="' + esc(L.decrease) + '">−</button>' +
          '<input type="number" name="quantity" value="1" min="1" max="99" aria-label="' + esc(L.quantity) + '">' +
          '<button type="button" data-step="1" aria-label="' + esc(L.increase) + '">+</button>' +
          '</div>' +
          '<button class="vb__btn" type="submit">' + esc(L.addToCart) + '</button>' +
          '</form>';
      } else {
        html += '<div class="vb__buy"><a class="vb__btn" href="' + esc(config.quoteUrl) + '">' + esc(L.addToQuote) + '</a></div>';
      }
      html += '<div class="vb__links">';
      if (p.datasheet) {
        html += '<a href="' + esc(p.datasheet) + '" target="_blank" rel="noopener"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 1.5h5.5L13 5v9.5H4z"/><path d="M9.5 1.5V5H13M6 8.5h4M6 11h4"/></svg>' + esc(L.datasheet) + '</a>';
      }
      html += '<a href="' + esc(p.url) + '">' + esc(L.productPage) + '</a>';
      if (hasPrice) html += '<a href="' + esc(config.quoteUrl) + '">' + esc(L.addToQuote) + '</a>';
      html += '</div></div></article>';
      return html;
    }

    function render() {
      var s = state();
      filters.forEach(function (f) {
        if (!f.dependsOn) return;
        var on = !s.source || s.source === f.dependsOn;
        f.el.classList.toggle('is-off', !on);
        Array.prototype.forEach.call(f.el.querySelectorAll('input'), function (i) { i.tabIndex = on ? 0 : -1; });
      });
      var hits = [];
      products.forEach(function (p, index) {
        var ok = filters.every(function (f) {
          if (f.ignored || !s[f.key]) return true;
          if (f.dependsOn && s.source && s.source !== f.dependsOn) return true;
          return MATCHERS[f.key](p, s[f.key], s);
        });
        if (ok) hits.push({ p: p, index: index, notes: notesFor(p, s, config.notes || {}) });
      });
      var active = filters.filter(function (f) { return !f.ignored && s[f.key]; }).length;
      if (countEl) {
        var count = esc(L.count)
          .replace('[shown]', '<strong>' + hits.length + '</strong>')
          .replace('[total]', products.length);
        if (active && L.applied) count += ' ' + esc(L.applied).replace('[count]', active);
        countEl.innerHTML = count;
      }
      cardsEl.innerHTML = hits.map(function (h, i) { return card(h.p, h.index, h.notes, i === 0 && active > 0); }).join('');
      emptyEl.hidden = hits.length > 0;
      emptyEl.innerHTML = esc(config.emptyText).replace('ask for a quote', '<a href="' + esc(config.quoteUrl) + '">ask for a quote</a>');
    }

    function toast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add('is-on');
      clearTimeout(toastEl.vbTimer);
      toastEl.vbTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
    }

    function addToCart(form) {
      var art = form.closest('.vb__card');
      var p = products[+art.getAttribute('data-index')];
      var qty = Math.min(99, Math.max(1, +form.quantity.value || 1));
      var items = [{ id: p.variantId, quantity: qty }];
      Array.prototype.forEach.call(art.querySelectorAll('[data-acc]:checked'), function (c) {
        var i = c.getAttribute('data-acc');
        var a = p.accessories[+i];
        var term = art.querySelector('[data-term="' + i + '"]');
        if (term) items.push({ id: +term.value, quantity: qty });
        else items.push({ id: a.variantId, quantity: (+c.getAttribute('data-qty') || 1) * qty });
      });

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      items.forEach(function (it, n) {
        fd.append('items[' + n + '][id]', it.id);
        fd.append('items[' + n + '][quantity]', it.quantity);
      });

      // No theme cart component to refresh: a plain form POST lands on /cart.
      if (!cart || !window.fetch) {
        Array.prototype.forEach.call(form.querySelectorAll('[data-gen]'), function (n) { n.remove(); });
        items.forEach(function (it, n) {
          ['id', 'quantity'].forEach(function (key) {
            var inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = 'items[' + n + '][' + key + ']';
            inp.value = it[key];
            inp.setAttribute('data-gen', '');
            form.appendChild(inp);
          });
        });
        form.quantity.disabled = true;
        form.submit();
        return;
      }

      var btn = form.querySelector('.vb__btn');
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = L.adding;
      fd.append('sections', cart.getSectionsToRender().map(function (sec) { return sec.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);

      fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            toast(res.description || L.cartError);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vendor-builder', productVariantId: p.variantId });
          }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
          toast(L.added);
        })
        .catch(function (e) {
          console.error(e);
          toast(L.cartError);
        })
        .finally(function () {
          btn.removeAttribute('aria-disabled');
          btn.textContent = L.addToCart;
        });
    }

    /* Events (delegated, so re-rendered cards need no rewiring) */
    filtersEl.addEventListener('change', render);
    root.querySelector('[data-vb-reset]').addEventListener('click', function () {
      filters.forEach(function (f) {
        var any = f.el.querySelector('input[value=""]') || f.el.querySelector('input');
        if (any) any.checked = true;
      });
      render();
    });
    filtersEl.addEventListener('click', function (e) {
      var tip = e.target.closest('.vb__tip');
      Array.prototype.forEach.call(filtersEl.querySelectorAll('.vb__tip.is-open'), function (o) {
        if (o !== tip) o.classList.remove('is-open');
      });
      if (tip) tip.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.vb__tip')) {
        Array.prototype.forEach.call(filtersEl.querySelectorAll('.vb__tip.is-open'), function (o) { o.classList.remove('is-open'); });
      }
    });

    cardsEl.addEventListener('click', function (e) {
      var media = e.target.closest('.vb__media');
      if (media) media.classList.toggle('is-shown');
      var step = e.target.closest('[data-step]');
      if (step) {
        var input = step.parentElement.querySelector('input');
        input.value = Math.min(99, Math.max(1, (+input.value || 1) + +step.getAttribute('data-step')));
      }
    });
    cardsEl.addEventListener('keydown', function (e) {
      var media = e.target.closest('.vb__media');
      if (media && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        media.classList.toggle('is-shown');
      }
    });
    cardsEl.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-buy]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    render();
    trackStickyHeader(root);
  }

  /* Keep the sticky filters and vendor card just below the theme's sticky header,
     which can be always-on or reveal-on-scroll-up. */
  function trackStickyHeader(root) {
    var header = document.querySelector('.shopify-section-header') || document.querySelector('sticky-header');
    if (!header) return;
    var ticking = false;
    // On wide screens the sticky header slides its nav row up behind the top row
    // (a transform, so the section box keeps its full height). Measure the rows.
    var rows = header.querySelectorAll('.header__top, .header__bottom');
    function visibleBottom() {
      if (!rows.length) return header.getBoundingClientRect().bottom;
      var bottom = 0;
      Array.prototype.forEach.call(rows, function (row) {
        bottom = Math.max(bottom, row.getBoundingClientRect().bottom);
      });
      return Math.min(bottom, header.getBoundingClientRect().bottom);
    }
    function update() {
      ticking = false;
      var bottom = Math.max(0, Math.round(visibleBottom()));
      root.style.setProperty('--vb-sticky-top', bottom + 16 + 'px');
    }
    var settle = null;
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
      // The header slides in and out with a transition; measure again once it settles.
      clearTimeout(settle);
      settle = setTimeout(update, 350);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    header.addEventListener('transitionend', update);
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-vendor-builder]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: section re-renders on every setting or block change.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
